@use '../../styles/Constants.scss' as Constants;

.modal {
	&__big-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: Constants.$val-fontSizeXBig;
		font-weight: bold;
		overflow: initial !important;

		&::before,
		&::after {
			display: none;
		}

		&__thin {
			font-size: Constants.$val-fontSizeXBig;
			font-weight: normal;
		}
	}

	&__body {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.img-preview {
		max-height: 500px;
		max-width: 600px;
	}
}